"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Threedoc_1 = __importDefault(require("../../../../assets/icons/Threedoc"));
const ModalReportNoti_1 = __importDefault(require("../../../../components/modal/ModalReportNoti"));
const ModalReportReason_1 = __importDefault(require("../../../../components/modal/ModalReportReason"));
const ModalReportSuccess_1 = __importDefault(require("../../../../components/modal/ModalReportSuccess"));
const mockData_1 = require("../../../../utils/mockData");
const components_1 = require("../../components");
const SubUserButton = (props) => {
    const { user, isBlocking, isBlocked, isMute, toggleBlockUser, toggleMuteUser } = props;
    const [modalVisible, setModalVisible] = (0, react_1.useState)(false);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [notiModalVisible, setNotiModalVisible] = (0, react_1.useState)(false);
    const [reportModalVisible, setReportModalVisible] = (0, react_1.useState)(false);
    const [checked, setChecked] = (0, react_1.useState)(0);
    const [violation, setViolation] = (0, react_1.useState)(0);
    const [alertVisible, setAlertVisible] = (0, react_1.useState)(false);
    const buttonMenuRef = (0, react_1.useRef)(null);
    const onButtonPress = (_) => {
        const position = buttonMenuRef.current?.getBoundingClientRect();
        setModalPosition({ x: position.right, y: position.bottom });
        setModalVisible(true);
    };
    const handleChecked = (itemId) => {
        setChecked(itemId);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.TouchableOpacity, { ref: buttonMenuRef, onPress: onButtonPress, style: {
                transform: [{ rotateZ: '90deg' }],
            } },
            react_1.default.createElement(Threedoc_1.default, null)),
        react_1.default.createElement(components_1.ModalSubUser, { visible: modalVisible, userId: user.user_id, userHandle: user?.user_handle, isBlocking: isBlocking, isBlocked: isBlocked, isMute: isMute, modalPosition: modalPosition, onClose: () => setModalVisible(false), onBlockUser: toggleBlockUser, onMuteUser: toggleMuteUser, onRepost: () => {
                setNotiModalVisible(true);
            } }),
        react_1.default.createElement(ModalReportNoti_1.default, { visible: notiModalVisible, data: mockData_1.Notification, onClose: () => {
                setNotiModalVisible(false), setChecked(0), setViolation(0);
            }, onNext: () => {
                setReportModalVisible(true);
                setNotiModalVisible(false);
            }, checkArray: checked, handleChecked: handleChecked, Violation: mockData_1.Violation, setViolation: (data) => {
                setViolation(data);
            } }),
        react_1.default.createElement(ModalReportReason_1.default, { visible: reportModalVisible, onClose: () => {
                setReportModalVisible(false), setChecked(0), setViolation(0);
            }, onNext: () => {
                setChecked(0);
                setViolation(0);
                setReportModalVisible(false);
                setAlertVisible(true);
            }, checked: checked, violation: violation, typeRepost: 'USER', idRepost: user.user_id }),
        react_1.default.createElement(ModalReportSuccess_1.default, { visible: alertVisible, onClose: () => {
                setAlertVisible(false);
            }, title: "\u3054\u5831\u544A\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059", textFirst: "\u5F53\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u5B89\u5168\u3068\u5FEB\u9069\u6027\u3092\u4FDD\u3064\u305F\u3081\u306B\u3054\u5354\u529B\u3044\u305F\u3060\u304D\u3001\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002", textSecond: "\u79C1\u305F\u3061\u306E\u30C1\u30FC\u30E0\u304C\u901A\u5831\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3001\u5FC5\u8981\u306A\u5BFE\u5FDC\u3092\u884C\u3044\u307E\u3059\u3002", textThirs: "\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u306B\u306F\u6570\u65E5\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u3054\u7406\u89E3\u304F\u3060\u3055\u3044\u3002", textFour: "\u901A\u5831\u306B\u95A2\u3057\u3066\u3055\u3089\u306A\u308B\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u304C\u5FC5\u8981\u306A\u5834\u5408\u3001\u307E\u305F\u306F\u72B6\u6CC1\u304C\u5909\u5316\u3057\u305F\u5834\u5408\u306F\u3001\u3044\u3064\u3067\u3082\u30B5\u30DD\u30FC\u30C8\u30C1\u30FC\u30E0\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002", textFive: "" })));
};
exports.default = SubUserButton;
